import styled from '@emotion/styled';
import { DEFAULT_BACKGROUND_SUBTLE_HIGHLIGHT_COLOR } from '../../styles/colors';
export const SubtleEntryPanelContainer = styled.div `
  background-color: ${DEFAULT_BACKGROUND_SUBTLE_HIGHLIGHT_COLOR};
  margin: 5px;
  padding: 10px;
  border-radius: 10px;
  color: #aaaaaa;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
